export const GET_MENU_REQUEST = "GET_MENU_REQUEST";
export const GET_MENU_SUCCESS = "GET_MENU_SUCCESS";
export const GET_MENU_FAIL = "GET_MENU_FAIL";

export const LOAD_MORE_ITEMS_REQUEST = "LOAD_MORE_ITEMS_REQUEST";
export const LOAD_MORE_ITEMS_SUCCESS = "LOAD_MORE_ITEMS_SUCCESS";
export const LOAD_MORE_ITEMS_FAIL = "LOAD_MORE_ITEMS_FAIL";


export const ADD_MENU_ITEMS_REQUEST = "ADD_MENU_ITEMS_REQUEST";
export const ADD_MENU_ITEMS_SUCCESS = "ADD_MENU_ITEMS_SUCCESS";
export const ADD_MENU_ITEMS_FAIL = "ADD_MENU_ITEMS_FAIL";
export const ADD_MENU_ITEMS_RESET = "ADD_MENU_ITEMS_RESET";


export const CLEAR_ERRORS = "CLEAR_ERRORS";


